<div
  class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
>
  <div class="d-flex">
    <app-go-back [marginClass]="''"></app-go-back>
    <h1 class="h3 text-info mx-2 my-auto">{{ 'countries.list.title' | translate }}</h1>
  </div>
  <div class="d-flex align-items-center">
    <app-is-guarded [permissions]="['CAN_CREATE_COUNTRY']">
      <a
        class="btn btn-info btn-sm text-sm text-white fw-bold mx-3"
        (click)="openCreateModal()"
      >
        {{ 'countries.list.newButton' | translate }}
      </a>
    </app-is-guarded>
    <a
      class="btn btn-info btn-sm text-sm text-white fw-bold mx-3"
      (click)="openImportModal()"
    >
      {{ 'countries.list.importButton' | translate }}
    </a>
    <button
      class="btn btn-info btn-sm text-sm text-white fw-bold mx-3"
      (click)="redirectToMap()"
    >
      {{ 'countries.list.viewMapButton' | translate }} <i-bs name="map"> </i-bs>
    </button>
  </div>
</div>

<div>
  <app-table
    *ngIf="countries$ | async as countries"
    [columnDefs]="columnDefs"
    [tableData]="countries"
    (actionInvoqueFunctionEvent)="tableActionsFunction($event)"
  >
  </app-table>
  <ng-template [ngIf]="error$ | async">
    <app-empty-card
      [icon]="'exclamation-circle'"
      [message]="'countries.list.emptyMessage' | translate"
    ></app-empty-card>
  </ng-template>
  <app-pagination
    *ngIf="pagination && (countries$ | async)?.length"
    [pagination]="pagination"
    (paginationEvent)="paginate($event)"
  ></app-pagination>
</div>

<modal #nGmodal [modalConfig]="modalConfig" class="modal-dialog-centered">
  <form
    *ngIf="modalFormType === 'CREATE' || modalFormType === 'UPDATE'"
    [formGroup]="modalForm"
  >
    <div class="mb-4">
      <label for="name" class="form-label fw-bold text-secondary">{{ 'countries.modal.form.countryLabel' | translate }} </label>
      <select
        (change)="selectPays()"
        id="name"
        formControlName="name"
        class="form-control form-select"
        [attr.aria-label]="'countries.modal.form.countryAriaLabel' | translate"
      >
        <option [ngValue]="''" selected>{{ 'countries.modal.form.countryPlaceholder' | translate }}</option>
        <option *ngFor="let country of allCountries" [ngValue]="country.name">
          {{ country.name }}
        </option>
      </select>
    </div>
    <div class="row">
      <div class="col-6 mb-3">
        <label for="iso" class="form-label fw-bold text-secondary">ISO:</label>
        <input
          type="text"
          id="iso"
          class="form-control border rounded"
          formControlName="iso"
        />
      </div>

      <div class="col-6 mb-3">
        <label for="currency_iso" class="form-label fw-bold text-secondary"
          >Devise Monétaire</label
        >
        <input
          type="text"
          id="currency_iso"
          class="form-control border rounded"
          formControlName="currency_iso"
        />
      </div>
    </div>
    <div class="mb-3">
      <label for="wave_enabled" class="form-label fw-bold text-secondary">{{ 'countries.modal.form.waveEnabledLabel' | translate }}</label>
      <select
        id="wave_enabled"
        formControlName="wave_enabled"
        class="form-control form-select"
        [attr.aria-label]="'countries.modal.form.waveStatusAriaLabel' | translate"
      >
        <option [ngValue]="true">{{ 'common.yes' | translate }}</option>
        <option [ngValue]="false">{{ 'common.no' | translate }}</option>
      </select>
    </div>
    <div class="mb-3 form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="sale_proof_required"
        formControlName="sale_proof_required"
      />
      <label for="sale_proof_required" class="form-check-label fw-bold text-secondary">{{ 'countries.modal.form.saleProofRequiredLabel' | translate }}</label>
    </div>
    <div class="mb-3 form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="ai_check_required"
        formControlName="ai_check_required"
      />
      <label for="ai_check_required" class="form-check-label fw-bold text-secondary">{{ 'countries.modal.form.aiCheckRequiredLabel' | translate }}</label>
    </div>
  </form>
  <p *ngIf="modalFormType === 'DELETE'">
    <strong>{{ 'countries.modal.deleteConfirmMessage' | translate }}</strong>
  </p>
  <p class="mt-4" *ngIf="!modalFormDisplay && modalFormStatusActionMessage">
    {{ modalFormStatusActionMessage }}
  </p>
</modal>

<modal #confirmModal [modalConfig]="confirmModalConfig" class="modal-dialog-centered">
  <p class="mb-0">{{ 'countries.modal.confirmDisableOption.message' | translate }}</p>
</modal>

<app-import-coordinates
  (dataReadyForImport)="importData($event)"
  [entity]="'COUNTRY'"
>
</app-import-coordinates>
